<template>
  <div id="icc-container" class="gdpr-container dark" v-if="show">
    <section class="gdpr-content">
      <p>
        <strong>This website uses cookies.</strong> We use technologies, such as cookies, to customise content and
        advertising, to provide social media features
        and to analyse traffic to the site. We also share information about your use of our site with our trusted
        social
        media, advertising and analytics partners.
      </p>
        <details>
          <summary v-on:click="showSettings=!showSettings">{{showSettings ? 'Less' : 'More'}} info.</summary>
          <ul v-if="showSettings">
            <li><label><input v-model="selectedCookieSettings" type="checkbox" value="necessary" checked disabled>Necessary</label></li>
            <li><label><input v-model="selectedCookieSettings" type="checkbox" value="preferences" checked>Preferences</label></li>
            <li><label><input v-model="selectedCookieSettings" type="checkbox" value="statistics" checked>Statistics</label></li>
            <li><label><input v-model="selectedCookieSettings" type="checkbox" value="marketing" checked>Marketing</label></li>
          </ul>
        </details>
        <button v-on:click="updateSettings">I agree</button>
    </section>
    <span class="gdpr-close" v-on:click="updateSettings">×</span>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import psl from 'psl';
  import {
    executeScriptsBySettingName,
    isArrayEqual,
    logResponse,
    getGeoIP
  } from './helpers';

  const COOKIE_SETTINGS = {
    NECESSARY: 'necessary',
    PREFERENCES: 'preferences',
    STATISTICS: 'statistics',
    MARKETING: 'marketing',
  };

  const COOKIE_SETTINGS_ALL = [
    COOKIE_SETTINGS.NECESSARY,
    COOKIE_SETTINGS.PREFERENCES,
    COOKIE_SETTINGS.STATISTICS,
    COOKIE_SETTINGS.MARKETING,
  ];

  const ICC_COOKIE_SETTINGS_NAME = 'ICC_SELECTED_SETTINGS';
  export default {
    name: 'icc',
    data() {
      return {
        show: false,
        showSettings: false,
        selectedCookieSettings: Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME) || COOKIE_SETTINGS_ALL,
        cookieSettings: COOKIE_SETTINGS,
        config: this.$parent.config,
      }
    },
    mounted() {
      const vm = this;

      let isRequiredToAnswer = true;

      if (vm.config.countries.length || vm.config.continents.length) {

        getGeoIP().then(result => {
          vm.userCountry = result.data.data0.country;

          isRequiredToAnswer = vm.config.countries.includes(result.data.data0.country) || vm.config.continents.includes(
            result.data.data0['continent-code']);

          if (!Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME) && isRequiredToAnswer) {
            vm.show = true;
          } 
          else if(!isRequiredToAnswer) {
            executeScriptsBySettingName(COOKIE_SETTINGS_ALL);
          } 
          else {
            executeScriptsBySettingName(Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME));
          }
        });
      } else {
        executeScriptsBySettingName(COOKIE_SETTINGS_ALL);
      }


      window.ICC.helpers = {
        getConsents: function () {
          return Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME)
        },
        hasConsentTo: function (consent) {
          return !!(Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME) && Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME).includes(
            consent));
        },
        togglePopup: function (show) {
          if (show === undefined) {
            vm.show = !vm.show;
          } else {
            vm.show = show;
          }
          vm.showSettings = false;
        },
        getAllCookies: function () {
          return Cookies.get();
        }
      };

      executeScriptsBySettingName(Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME));
    },
    methods: {
      updateSettings: function () {

        const DOMAIN = psl.get(window.location.hostname);
        this.show = !this.selectedCookieSettings;

        const prevCookieSelections = Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME);
        Cookies.set(ICC_COOKIE_SETTINGS_NAME, this.selectedCookieSettings, { domain: DOMAIN });
        const cookieSettings = Cookies.getJSON(ICC_COOKIE_SETTINGS_NAME);
        executeScriptsBySettingName(cookieSettings);
        logResponse(cookieSettings, this.userCountry,
          () => {
            if (!isArrayEqual(prevCookieSelections, cookieSettings)) {
              window.location.reload();
            }
          });
      }
    }
  }

  // 'Necessary' is always loaded no matter what!
  executeScriptsBySettingName(['necessary']);

</script>

<style lang="scss" scoped>

  .gdpr-container {
    background: #333;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    font-size: 10px;
    color: #fff;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial';
    z-index: 200;
  }

  .gdpr-container.light {
    color: #222;
    background: #ddd;
  }

  .gdpr-content {
    max-width: 1080px;
    margin: auto;
    padding: 30px 20px;
  }

  .gdpr-content p {
    font-size: 1.4em;
    display: inline-block;
    line-height: 1.5;
    margin: 0;
    padding-bottom: 10px;
  }

  .gdpr-content p a {
    color: cornflowerblue;
  }

  .gdpr-content button {
    margin-left: 10px;
    background: limegreen;
    color: #fff;
    border: none;
    border-radius: 3px;
    padding: 5px 10px;
    display: inline-block;
  }

  .gdpr-content details {
    display: inline-block;
  }

  .gdpr-content details summary {
    color: cornflowerblue;
    font-size: 1.4em;
  }

  .gdpr-content details summary:hover {
    cursor: pointer;
  }

  .gdpr-content ul {
    list-style: none;
    margin: 10px 0;
    padding: 0;
  }

  .gdpr-content ul li {
    display: inline-block;
    font-size: 1.4em;
    margin-right: 20px;
  }

  .gdpr-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue